import APIConfiguration from '@savgroup-front-common/configuration/api';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import { apiCall } from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

import { EXPORT_JOB_STATUS } from '@/api/Search/getExportJobQuery';

const ENDPOINT = `${APIConfiguration.search}export/jobs/byBulkActionJobId`;

interface GetExportJobQueryResponseValue {
  status: EXPORT_JOB_STATUS;
  downloadToken: string;
}

export const getExportJobsByBulkActionJobIdQuery = async ({
  bulkActionJobId,
}: {
  bulkActionJobId: string;
}): Promise<
  BackResponse<GetExportJobQueryResponseValue[]> | BackResponseFailure
> => {
  try {
    const url = buildUrl(ENDPOINT, {
      bulkActionJobId,
    });
    const response = await apiCall<
      BackResponse<GetExportJobQueryResponseValue[]>
    >(url, {
      method: SUPPORTED_METHODS.GET,
    });

    return response;
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
